module.exports = __webpack_public_path__ + "assets/img/18_180_big.4560172f.jpg";